import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  Order,
  PaginatedData,
  PaginatedRequestResponse,
  RequestResponse,
} from '@/types';

export const fetchOrders = async ({
  page,
  pageSize,
}: {
  page?: number;
  pageSize?: number;
} = {}): Promise<PaginatedData<Order[]>> => {
  const response = await axiosInstance<PaginatedRequestResponse<Order[]>>(
    endpoints.orders,
    {
      params:
        typeof page === 'number' || typeof pageSize === 'number'
          ? { page, pageSize }
          : undefined,
    }
  );

  const paginated = response.data.data;
  return {
    ...paginated,
    data: Array.isArray(paginated?.data) ? paginated.data : [],
  };
};

export const fetchOrder = async (uuid: string) => {
  const response = await axiosInstance<RequestResponse<Order>>(
    `${endpoints.orders}/${uuid}`
  );
  return response.data.data;
};
